import { PublicClientApplication } from '@azure/msal-browser';
import { env } from '@sib/config';

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: env.azureClientId || '',
    authority: `https://login.microsoftonline.com/${env.azureTenantId}`,
    redirectUri: `${window.location.origin}/login`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    // Ref: https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/4206
    tokenRenewalOffsetSeconds: 35 * 60,
  },
});

export { msalInstance };
